import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const ContactForm = () => {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    setLoading(true);
    setSubmitted(false);
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 3000); // Hide after 3 sec
    }, 2000);
  };

  return (
    <motion.form
      action="https://formsubmit.co/submit@iburtum.xyz"
      method="POST"
      encType="multipart/form-data"
      className="max-w-md mx-auto p-6 glass rounded-lg text-center"
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="text-2xl font-bold primary-text mb-4">{t("contact.title")}</h2>

      {/* Hidden Inputs */}
      <input type="hidden" name="_captcha" value="false" />
      <input type="hidden" name="_next" value="https://iburtum.xyz" />

      <div className="custom-input">
        <input type="text" name="name" id="name" placeholder=" " required dir="auto" />
        <label htmlFor="name">{t("contact.name")}</label>
      </div>
      <div className="custom-input">
        <input type="email" name="email" id="email" placeholder=" " required dir="auto" />
        <label htmlFor="email">{t("contact.email")}</label>
      </div>
      <div className="custom-input">
        <textarea
          name="message"
          id="message"
          placeholder=" "
          className="w-full"
          rows="4"
          required
          dir="auto"
        ></textarea>
        <label htmlFor="message">{t("contact.message")}</label>
      </div>
      <div className="custom-file-input">
        <input
          type="file"
          name="attachment"
          id="attachment"
          onChange={handleFileChange}
          className="hidden"
        />
        <label htmlFor="attachment" className="cursor-pointer primary-text">
          {file ? file.name : t("contact.file")}
        </label>
      </div>

      <button
        type="submit"
        className="w-full p-2 mt-4 bg-transparent border border-blue-500 primary-text hover:bg-blue-500 hover:text-white rounded transition-all flex items-center justify-center"
        disabled={loading}
      >
        {loading ? <div className="loading-spinner mr-2"></div> : t("contact.button")}
      </button>

      {/* ✅ Green Checkmark */}
      {submitted && (
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0 }}
          className="mt-4 w-8 h-8 mx-auto bg-green-500 rounded-full flex items-center justify-center text-white"
        >
          ✓
        </motion.div>
      )}
    </motion.form>
  );
};

export default ContactForm;
